import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { dataGroupMapRef } from './consts';

export default grapesjs.plugins.add('gjs-data-group-map', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: dataGroupMapRef,
    blocks: [dataGroupMapRef],
    defaultStyle: true,
    labelGroupMap: 'DataGroup Map',
    labelGroupMapCategory: 'Components',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
